<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
	  name: 'App',
	  data(){
		  return{

		  }
    },
  }
</script>

<style>
  *{margin: 0;}
html,body{
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  min-height: 100%;
  background: url(../static/bg.png) no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue